module.exports = __webpack_public_path__ + "static/media/Image-1_7.662aeb83.jpg";